{
  "RingtimeDistributionLabel": "Klingelzeit (Verteilung):",
  "RingtimeSegmentLabel": "Klingelzeit (Segment):",
  "CalltalktimeLabel": "Gesprächszeit anrufen:",
  "TotalcalltimeLabel": "Gesamtanrufzeit:",
  "CallheldtimeLabel": "Anruf gehalten Zeit:",
  "TimeComparisonAnyOptionLabel": "[Irgendein]",
  "TimeComparisonHigherthanOptionLabel": "Höher als",
  "TimeComparisonHigherequalOptionLabel": "Höher\/Gleich",
  "TimeComparisonLowerthanOptionLabel": "Niedriger als",
  "TimeComparisonLowerequalOptionLabel": "Niedriger\/Gleich",
  "TimeComparisonBetweenOptionLabel": "Zwischen",
  "TimeComparisonEqualOptionLabel": "Gleich",
  "TimeComparisonNotequalOptionLabel": "Nicht gleich",
  "TimeComparisonNotbetweenOptionLabel": "Nicht zwischen",
  "TimeComparisonValue1Label": "Wert:",
  "TimeComparisonValue2Label": "Und:",
  "DurationFiltering_SectionHeader": "Dauerfilterung (nur historisch)",
  "NAME": "DurationFiltering"
}